module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pYQusU/image/1.png?1685790608499",
      "alt": "This image is the cover for the book True Love"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("True Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Uriel has a lot of questions about life and is determined to know the answers. Through inquiry, exploration, chance, experience and realization, all of these questions are answered over a lifetime of truly living. Join Uriel as he uncovers and awakens to the true meaning of life.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joshua Lewan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joshua Lewan is from Byron Bay and lives in Mullumbimby, Australia. He was clinically diagnosed with Asperger Syndrome on the Autism Spectrum and is an advocate for neurodiversity, freedom/freedom of speech, spirituality/consciousness, unconditional love and natural health/medicines. "), _c('br'), _vm._v("Josh finished a diploma in Shamanism, has studied Traditional Chinese Medicine Remedial Massage Therapy and also has a diploma in Intuitive Spiritual Healing. He has worked as a healer for several years and is a music artist.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0